import { getRaw } from "@scalar/json-magic/magic-proxy";
const mergeObjects = (a, b, cache = /* @__PURE__ */ new Set()) => {
  for (const key in b) {
    if (!(key in a)) {
      a[key] = b[key];
    } else {
      const aValue = a[key];
      const bValue = b[key];
      if (typeof aValue === "object" && aValue !== null && typeof bValue === "object" && bValue !== null) {
        const rawA = getRaw(aValue);
        const rawB = getRaw(bValue);
        if (cache.has(rawA) || cache.has(rawB)) {
          continue;
        }
        cache.add(rawA);
        cache.add(rawB);
        mergeObjects(aValue, bValue, cache);
      } else {
        a[key] = bValue;
      }
    }
  }
  return a;
};
export {
  mergeObjects
};
//# sourceMappingURL=merge-object.js.map
